import { useTranslation } from 'react-i18next';
import SanitizeRaw from '../SanitizeRaw';

interface Props {
  className?: string;
  i18nKey: string;
}

/**
 * This component is used to render translated strings in their raw HTML form,
 * using SanitizeRaw component to prevent any potential security vulnerabilities.
 */
function TransRaw({ className, i18nKey }: Props): JSX.Element {
  const { t: translate } = useTranslation();

  return (
    <SanitizeRaw
      className={className}
      contents={translate(i18nKey, ' ') || ''}
    />
  );
}

export default TransRaw;
